import React from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

const CalendarTodayIconWrapper = () => {
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

  return !isMdUp ? (
    <div style={{ fontSize: '40px' }}>
      <CalendarTodayIcon
        fontSize="inherit"
        color={theme.palette.primary.main}
      />
    </div>
  ) : (
    <CalendarTodayIcon
      fontSize="small"
      htmlColor={theme.palette.primary.main}
    />
  );
};
export { CalendarTodayIconWrapper };
